import { render } from "./ListaRegistros.vue?vue&type=template&id=6858d1ba"
import script from "./ListaRegistros.vue?vue&type=script&lang=js"
export * from "./ListaRegistros.vue?vue&type=script&lang=js"

import "./ListaRegistros.vue?vue&type=style&index=0&id=6858d1ba&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__